module.exports = {
    "im.messageList.orderNumber": "订单号",
    "page.im.window.label.productId": "商品ID",
    "im.messageList.productTitle": "商品信息"
};